import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { setCompliantLocalStorageItem } from './actions';
import { getCompliantLocalStorageItem } from './selectors';
export function useLocalStorageValue(key, stringToValue, valueToString) {
    const localStorageValue = useSelector(partialRight(getCompliantLocalStorageItem, key));
    const [bufferValue, setBufferValue] = useState(stringToValue(localStorageValue));
    const dispatch = useDispatch();
    const handleSetBufferValue = useCallback((value)=>{
        setBufferValue(value);
        dispatch(setCompliantLocalStorageItem({
            key,
            value: valueToString(value)
        }));
    }, [
        dispatch,
        key,
        valueToString
    ]);
    return [
        bufferValue,
        handleSetBufferValue
    ];
}
export function useBooleanLocalStorageValue(key) {
    return useLocalStorageValue(key, (v)=>v === 'true', (v)=>`${v}`);
}

//# sourceMappingURL=hooks.js.map